module.exports = __webpack_public_path__ + "static/media/5078-HPA_Bylaws_Community.80aebe62.pdf";